<template>
  <div>
    <form-dialog v-model="isActive" :sending="sending" @confirm="onConfirm">

      <div slot="title">
        <span class="mr-2 left line-height-24">{{ edit ? $t('prenotazioni.azioni.modifica') + ' #' + form.id :
          $t('prenotazioni.azioni.nuovo') }}</span>
        <alert-chip v-if="edit && form.pendente !== 0" color="warning" class="left">
          {{ $t('prenotazioni.errori.modifiche_da_confermare') }}
        </alert-chip>
      </div>

      <v-flex xs12>
        <icon-label icon="access_time" color="accent">{{ $t('prenotazioni.label.dati_prenotazione') }}</icon-label>
      </v-flex>

      <v-flex xs12 md4>
        <date-picker :label="$t('prenotazioni.label.data')" v-model="form.data_controllo" :locale="$i18n.locale"
          required />
      </v-flex>

      <v-flex xs12 md8>
        <agricoltori-select :label="$t('label.cliente')" v-model="form.id_agricoltore" required attach />
      </v-flex>

      <v-flex xs12 md4>
        <time-picker :label="$t('prenotazioni.label.orario')" v-model="form.ora_controllo" required />
      </v-flex>

      <v-flex xs12 sm6 md4>
        <tecnici-select :label="$t('prenotazioni.label.tecnico')" v-model="form.id_tecnico" clearable attach />
      </v-flex>

      <v-flex xs12 sm6 md4>
        <unita-mobili-select :label="$t('label.unita_mobile')" v-model="form.targa_unita_mobile" attach />
      </v-flex>

      <v-flex xs12 class="mt-4">
        <icon-label icon="location_on" color="accent">{{ $t('prenotazioni.label.luogo_controllo') }}</icon-label>
      </v-flex>

      <v-flex class="shrink">
        <v-tooltip bottom>
          <v-btn flat icon slot="activator">
            <v-icon>help_outline</v-icon>
          </v-btn>
          <span>{{ $t('prenotazioni.label.inserisci_indirizzo') }}</span>
        </v-tooltip>
      </v-flex>

      <v-flex class="shrink btn--indirizzo">
        <v-btn small color="accent" @click="onIndirizzoClick(0)">{{ $t('label.azienda') }}</v-btn>
        <v-btn small color="accent" @click="onIndirizzoClick(1)" :disabled="!form.id_agricoltore">{{ $t('label.cliente')
          }}</v-btn>
        <v-btn small color="accent" @click="onIndirizzoClick(2)" :disabled="!form.id_agricoltore">{{
          $t('label.convenzione') }}</v-btn>
      </v-flex>

      <v-flex class="shrink">
        <v-progress-circular v-show="loadingAddress" indeterminate size="22" class="mt-2" color="accent" width="3" />
      </v-flex>

      <v-flex class="grow">
        <v-checkbox :label="$t('prenotazioni.label.compilato_in_convenzione')" v-model="form.compilato_in_convenzione"
          hide-details class="mt-1" />
      </v-flex>

      <v-flex xs12>
        <indirizzo-select :paese.sync="form.nazione" :regione.sync="form.regione" :provincia.sync="form.provincia"
          :comune.sync="form.comune" :cap.sync="form.cap" :frazione.sync="form.frazione" :via.sync="form.via"
          :numero-civico.sync="form.numero_civico" show-frazione required attach />
      </v-flex>

      <v-flex xs12 class="mt-4">
        <icon-label icon="assignment" color="accent">{{ $t('prenotazioni.label.dati_irroratrice') }}</icon-label>
      </v-flex>

      <v-flex xs12>
        <v-layout>
          <v-flex class="shrink">
            <span class="input-label subheading">{{ $t('prenotazioni.label.tipologia_irroratrice') }}</span>
          </v-flex>
          <v-flex class="shrink">
            <v-radio-group v-model="form.dettagli.tipo" row mandatory hide-details single-line>
              <v-radio :label="$t('prenotazioni.label.erbacee')" :value="0"></v-radio>
              <v-radio :label="$t('prenotazioni.label.arboree')" :value="1"></v-radio>
              <v-radio :label="$t('prenotazioni.label.altro') + ':'" :value="2"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex>
            <text-field :label="$t('prenotazioni.label.altro')" v-model="form.dettagli.tipo_altro"
              :disabled="form.dettagli.tipo !== 2" single-line />
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12>
        <macchina-select :marca.sync="form.dettagli.marca" :modello.sync="form.dettagli.modello"
          :numero_serie.sync="form.dettagli.numero_serie" :idAgricoltore=this.form.id_agricoltore required attach />
      </v-flex>

      <v-flex xs12 sm6 md4>
        <date-picker :label="$t('prenotazioni.label.data_primo_acquisto')" v-model="form.dettagli.data_primo_acquisto"
          :locale="$i18n.locale" />
      </v-flex>

      <v-flex xs12 sm6 md4>
        <text-field :label="$t('prenotazioni.label.anno_costruzione')" v-model="form.dettagli.anno_costruzione"
          mask="####" />
      </v-flex>

      <v-flex xs12 sm6 md4>
        <date-picker :label="$t('prenotazioni.label.data_primo_acquisto_presunta')"
          v-model="form.dettagli.data_primo_acquisto_presunta" :locale="$i18n.locale" />
      </v-flex>

      <v-flex xs12>
        <v-checkbox :label="$t('prenotazioni.label.disponibilita_manutenzione')"
          v-model="form.dettagli.disponibilita_manutenzione" hide-details />
      </v-flex>

      <v-flex xs12>
        <v-checkbox :label="$t('prenotazioni.label.richiesta_taratura')" v-model="form.dettagli.richiesta_taratura"
          hide-details />
      </v-flex>

      <v-flex xs12>
        <v-textarea :label="$t('prenotazioni.label.note')" v-model="form.note" box auto-grow maxlength="500"
          counter="500" />
      </v-flex>

      <prenotazione-warning-dialog ref="warningDialog" @confirm="onConfirm(true)" />

    </form-dialog>

    <!-- TEMPLATE PER IL PDF (sopra ita sotto de)
    <div class="pdf-offscreen-wrapper">
      <div ref="pdfTemplate" class="pdf-document">

        <div class="pdf-header">
          <div class="logo-left" v-if="azienda.show_logo_beratungsring">
            <img :src="logoBeratungsring" alt="beratungsring.org" />
          </div>
          <div class="logo-right" v-if="azienda.show_logo_azienda">
            <img :src="logoAzienda" alt="logoAzienda" />
          </div>
        </div>

        <h1 class="doc-title">
          Conferma della prenotazione per il controllo funzionale
          <span class="lang-it">Bestätigung der Anmeldung zur Funktionskontrolle</span>
        </h1>

        <p class="text-block">
          Con la presente si conferma che il dispositivo
          <span class="lang-it">Es wird hiermit bestätigt, dass das Gerät</span>
        </p>

        <table class="data-table">
          <tr>
            <td class="label">marca: <span class="lang-it">Marke:</span></td>
            <td class="value">{{ form.dettagli.marca || '-' }} {{ form.dettagli.modello || '' }}</td>
          </tr>
          <tr>
            <td class="label">n° telaio: <span class="lang-it">Rahmen/Seriennummer:</span></td>
            <td class="value">{{ form.dettagli.numero_serie || '-' }}</td>
          </tr>
          <tr class="spacer-row"><td colspan="2"></td></tr>
          <tr>
            <td class="label">dell'azienda agricola: <span class="lang-it">des landwirtschaftlichen Betriebs:</span></td>
            <td class="value">{{ datiExtra.nomeCliente || '-' }}</td>
          </tr>
          <tr>
            <td class="label">cod. fiscale: <span class="lang-it">Steuernummer:</span></td>
            <td class="value">{{ datiExtra.cuaa || '-' }}</td>
          </tr>
        </table>

        <p class="text-block text-margin">
          è stato prenotato presso il centro prova
          <span class="lang-it">zur Funktionskontrolle bei folgender Prüfstelle angemeldet ist</span>
        </p>

        <div class="indented-block">
          <p class="font-bold">{{ datiExtra.centroProvaCodice }}</p>
          <p>{{ datiExtra.centroProvaNome }}</p>
          <p>{{ form.via }} {{ form.numero_civico }}</p>
          <p>{{ form.cap }} {{ nomeComune }} ({{ nomeProvincia }})</p>
        </div>

        <p class="text-block text-margin">
          Per motivi organizzativi, il controllo del funzionamento avrà luogo il
          <span class="lang-it">Die Funktionskontrolle wird aus organisatorischen Gründen am</span>
        </p>

        <div class="indented-block">
          <p>
            <span class="font-bold">{{ formattaData(form.data_controllo) }}</span>
            alle
            <span class="font-bold">{{ form.ora_controllo }}</span>.
          </p>
          <p class="lang-it">
            am <span class="font-bold">{{ formattaData(form.data_controllo) }}</span>
            um <span class="font-bold">{{ form.ora_controllo }}</span> Uhr durchgeführt.
          </p>
        </div>

        <div class="footer-signature">
          <div class="date-side">
            <p>Data: {{ dataOggi }}</p>
            <p class="lang-it">Datum: {{ dataOggi }}</p>
          </div>
          <div class="signature-side">
            <p class="font-bold">Il tecnico <span class="lang-it font-normal">Der technische Prüfer</span></p>
            <img :src="firmaTecnico" alt="FIRMA TECNICO" class="firma-img" v-if="firmaTecnico" />
            <p>{{ datiExtra.nomeTecnico || '-' }}</p>
          </div>
        </div>

      </div>
    </div> -->
    <div class="pdf-offscreen-wrapper">
      <div ref="pdfTemplate" class="pdf-document">

        <!-- HEADING LOGHI (invariato) -->
        <div class="pdf-header">
          <div class="logo-left" v-if="azienda.show_logo_beratungsring">
            <img :src="logoBeratungsring" alt="beratungsring.org" />
          </div>
          <div class="logo-right" v-if="azienda.show_logo_azienda">
            <img :src="logoAzienda" alt="logoAzienda" />
          </div>
        </div>

        <!-- TITOLO BILINGUE -->
        <h1 class="doc-title">
          Bestätigung der Anmeldung zur Funktionskontrolle
          <span class="lang-it">Conferma della prenotazione per il controllo funzionale</span>
        </h1>

        <!-- CORPO -->
        <p class="text-block">
          Es wird hiermit bestätigt, dass das Gerät
          <span class="lang-it">Con la presente si conferma che il dispositivo</span>
        </p>

        <!-- TABELLA DATI DISPOSITIVO -->
        <table class="data-table">
          <tr>
            <td class="label">Marke: <span class="lang-it">marca:</span></td>
            <td class="value">{{ form.dettagli.marca || '-' }} {{ form.dettagli.modello || '' }}</td>
          </tr>
          <tr>
            <td class="label">Rahmen/Seriennummer: <span class="lang-it">n° telaio:</span></td>
            <td class="value">{{ form.dettagli.numero_serie || '-' }}</td>
          </tr>
          <tr class="spacer-row"><td colspan="2"></td></tr>
          <tr>
            <td class="label">des landwirtschaftlichen Betriebs: <span class="lang-it">dell'azienda agricola:</span></td>
            <td class="value">{{ datiExtra.nomeCliente || '-' }}</td>
          </tr>
          <tr>
            <td class="label">Steuernummer: <span class="lang-it">cod. fiscale:</span></td>
            <td class="value">{{ datiExtra.cuaa || '-' }}</td>
          </tr>
        </table>

        <p class="text-block text-margin">
          zur Funktionskontrolle bei folgender Prüfstelle angemeldet ist
          <span class="lang-it">è stato prenotato presso il centro prova</span>
        </p>

        <!-- CENTRO PROVA -->
        <div class="indented-block">
          <p class="font-bold">{{ datiExtra.centroProvaCodice }}</p>
          <p>{{ datiExtra.centroProvaNome }}</p>
          <p>{{ form.via }} {{ form.numero_civico }}</p>
          <p>{{ form.cap }} {{ nomeComune }} ({{ nomeProvincia }})</p>
        </div>

        <p class="text-block text-margin">
          Die Funktionskontrolle wird aus organisatorischen Gründen am
          <span class="lang-it">Per motivi organizzativi, il controllo del funzionamento avrà luogo il</span>
        </p>

        <!-- DATA E ORA PRENOTAZIONE -->
        <div class="indented-block">
          <p>
            <span class="font-bold">{{ formattaData(form.data_controllo) }}</span>
            um <span class="font-bold">{{ form.ora_controllo }}</span> Uhr durchgeführt.
          </p>
          <p class="lang-it">
            <span class="font-bold">{{ formattaData(form.data_controllo) }}</span>
            alle <span class="font-bold">{{ form.ora_controllo }}</span>.
          </p>
        </div>

        <!-- FIRMA E DATA EMISSIONE -->
        <div class="footer-signature">
          <div class="date-side">
            <p>Datum: {{ dataOggi }}</p>
            <p class="lang-it">Data: {{ dataOggi }}</p>
          </div>
          <div class="signature-side">
            <p class="font-bold">Der technische Prüfer <span class="lang-it font-normal">Il tecnico</span></p>
            <img :src="firmaTecnico" alt="FIRMA TECNICO" class="firma-img" v-if="firmaTecnico" />
            <p>{{ datiExtra.nomeTecnico || '-' }}</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { jsPDF } from 'jspdf/dist/jspdf.umd.min.js'
import html2canvas from 'html2canvas'
import { mapGetters } from 'vuex'
import Sendable from '@/mixins/sendable'
import {
  DatePicker,
  TimePicker,
  AgricoltoriSelect,
  TecniciSelect,
  UnitaMobiliSelect,
  IndirizzoSelect,
  MacchinaSelect
} from '@/components/inputs'
import FormDialog from './base/FormDialog'
import PrenotazioneWarningDialog from '@/components/PrenotazioneWarningDialog'

export default {
  name: 'PrenotazioneDialog',
  mixins: [Sendable],
  components: {
    DatePicker,
    TimePicker,
    AgricoltoriSelect,
    TecniciSelect,
    UnitaMobiliSelect,
    IndirizzoSelect,
    MacchinaSelect,
    FormDialog,
    PrenotazioneWarningDialog
  },
  data() {
    return {
      defaultData: this.$schemas().prenotazione,
      loadingAddress: false,
      azienda: this.$store.state.global.azienda,
      logoBeratungsring: require('@/assets/logo_beratungsring.png'),
      logoAzienda: this.$api.azienda.getLogoUrl(),
      firmaTecnico: null,
      datiExtra: {
        nomeCliente: '',
        cuaa: '',
        centroProvaCodice: '',
        centroProvaNome: '',
        nomeTecnico: ''
      }
    }
  },
  computed: {
    ...mapGetters(['getAgricoltoreById']),
    agricoltoreSelezionato() {
      return this.getAgricoltoreById(this.form.id_agricoltore)
    },
    nomeProvincia() {
      const lista = this.$store.getters.province(this.form.regione)
      const trovata = lista && lista.find(p => p.id === this.form.provincia)
      return trovata ? trovata.nome : '-'
    },
    nomeComune() {
      const lista = this.$store.getters.comuni(this.form.provincia)
      const trovata = lista && lista.find(c => c.id === this.form.comune)
      return trovata ? trovata.nome : '-'
    },
    dataOggi() {
      const today = new Date()
      return today.toLocaleDateString('it-IT')
    },
    indirizzo: {
      get() {
        return {
          nazione: this.form.nazione,
          regione: this.form.regione,
          provincia: this.form.provincia,
          comune: this.form.comune,
          cap: this.form.cap,
          frazione: this.form.frazione,
          via: this.form.via,
          numero_civico: this.form.numero_civico
        }
      },
      set(val) {
        this.form.nazione = val.nazione
        this.form.regione = val.regione
        this.form.provincia = val.provincia
        this.form.comune = val.comune
        this.form.cap = val.cap
        this.form.frazione = val.frazione || ''
        this.form.via = val.via
        this.form.numero_civico = val.numero_civico
      }
    }
  },
  methods: {
    onIndirizzoClick(val) {
      this.form.compilato_in_convenzione = (val === 2)
      switch (val) {
        case 0: //  Azienda
          this.indirizzo = this.$store.state.global.azienda
          break
        case 1: //  Agricoltore
          this.loadingAddress = true
          this.$api.indirizzo.getByAgricoltore(this.form.id_agricoltore).then(response => {
            this.loadingAddress = false
            this.indirizzo = response.data
          })
          break
        case 2: //  Convenzione
          this.loadingAddress = true
          this.$api.indirizzo.getByConvenzioneOfAgricoltore(this.form.id_agricoltore).then(response => {
            this.loadingAddress = false
            if (!response.data) {
              this.$snackbar.show(this.$t('prenotazioni.errori.agricoltore_no_convenzione'), 'error')
            } else {
              this.indirizzo = response.data
            }
          })
          break
      }
    },
    action(force = false) {
      let data = Object.assign({}, this.form)

      data.dettagli = JSON.stringify(this.form.dettagli)
      if (this.edit) {
        if (force) return this.$api.prenotazioni.forceUpdate(data.id, data)
        else return this.$api.prenotazioni.update(data.id, data)
      } else {
        if (force) return this.$api.prenotazioni.forceCreate(data)
        else return this.$api.prenotazioni.create(data)
      }
    },
    async generaESalvaPDF(id) {
      await this.$nextTick() // Attende che Vue aggiorni il DOM
      const agricoltore = this.$store.getters.getAgricoltoreById(this.form.id_agricoltore)
      const element = this.$refs.pdfTemplate
      const data = this.form.data_controllo.replaceAll('-', '')
      let telaio = this.form.dettagli.numero_serie.replaceAll(/[\/\\]/g, '$').trim();
      
      const filename = `${data}_${telaio}_${agricoltore.cuaa}.pdf`
      console.log(filename)
      try {
        const canvas = await html2canvas(element, {
          scale: 2,
          useCORS: true,
          logging: false,
          windowWidth: 1024 // Previene problemi di calcolo responsivo
        })

        // Controllo di sicurezza sulle dimensioni calcolate
        if (canvas.width === 0 || canvas.height === 0) {
          throw new Error("L'elemento HTML del PDF ha dimensioni nulle.")
        }

        const imgData = canvas.toDataURL('image/jpeg', 0.98)
        const pdf = new jsPDF('p', 'mm', 'a4')

        const imgWidth = 210
        const imgHeight = (canvas.height * imgWidth) / canvas.width

        pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight)

        // Scarica direttamente nel browser
        // pdf.save(filename)

        // Invia al server backend
        const pdfBlob = pdf.output('blob')
        const formData = new FormData()
        formData.append('pdf_file', pdfBlob, filename)
        //formData.append('id_prenotazione', prenotazioneId)

        await this.$api.prenotazioni.salvaPdf(id, formData)
      } catch (err) {
        console.error('Errore durante la generazione PDF:', err)
      }
    },
    async onConfirm(force = false) {
      await new Promise(resolve => setTimeout(resolve, 100));
      this.sending = true
      this.action(force).then(async response => {
        const prenotazioneCreato = response.data
        const id = (prenotazioneCreato && prenotazioneCreato.id) ? prenotazioneCreato.id : this.form.id

        if (!this.edit) {
          //  Salvo l'ultimo indirizzo inserito in modo da renderlo disponibile alla prossima apertura della pagina
          this.$store.commit('SET_LAST_INDIRIZZO', this.indirizzo)
        }

        //  Recupero i dati mancanti dallo store prima di generare il PDF
        const agricoltore = this.$store.getters.getAgricoltoreById(this.form.id_agricoltore)
        const tecnico = this.$store.getters.getTecnicoById(this.form.id_tecnico)

        this.datiExtra = {
          nomeCliente: agricoltore ? agricoltore.ragione_sociale : '-',
          cuaa: agricoltore ? agricoltore.cuaa : '-',
          centroProvaCodice: this.azienda ? this.azienda.numero_centro : '-',
          centroProvaNome: this.azienda ? this.azienda.ragione_sociale : '-',
          nomeTecnico: tecnico ? tecnico.nome_cognome : '-'
        }

        this.firmaTecnico = await this.$api.tecnici.getFirmaUrl(this.form.id_tecnico)

        await this.generaESalvaPDF(id)

        this.onSuccess(this.edit ? this.$t('prenotazioni.messaggi.modificato') : this.$t('prenotazioni.messaggi.creato'))

      }).catch(e => {
        this.sending = false
        if (e.response && e.response.data[0] && e.response.data[0].errore) {
          //  C'è un problema con gli orari delle prenotazioni, mostro un alert
          this.$refs.warningDialog.show(e.response.data)
        } else if (e.response && e.response.status === 404 && e.response.data.message === 'in use') {
          //  La prenotazione è collegata ad un report già compilato
          this.onError(this.$t('prenotazioni.errori.riferimenti_attivi_edit'))
        } else {
          this.onError(this.$t('errori.server'))
        }
      })

      if (MacchinaSelect != null) {
        this.addMacchina();
      }
    },
    addMacchina() {
      // Creazione di un oggetto con i dati della macchina selezionata
      let dataMacchina = {
        marca: this.form.dettagli.marca,
        modello: this.form.dettagli.modello,
        numero_serie: this.form.dettagli.numero_serie,
        id_agricoltore: this.form.id_agricoltore
      };

      // Variabile per tenere traccia se la macchina è già presente
      let marcaTrovata = false;
      let modelloTrovato = false;
      let numeroSerieTrovato = false;

      console.log(dataMacchina);
      this.$api.macchine.getForCliente(this.form.id_agricoltore).then(response => {

        // Iterazione su tutte le macchine per verificare se esistono già
        response.data.forEach(element => {
          if (element.marca === dataMacchina.marca) {
            marcaTrovata = true;
            if (element.modello === dataMacchina.modello) {
              modelloTrovato = true;
              if (element.numero_serie === dataMacchina.numero_serie) {
                numeroSerieTrovato = true;
              }
            }
          }
        });

        if (!marcaTrovata || (marcaTrovata && !modelloTrovato) || (marcaTrovata && modelloTrovato && !numeroSerieTrovato)) {
          this.$api.macchine.create(dataMacchina);
        } else {
          marcaTrovata = false;
          modelloTrovato = false;
          numeroSerieTrovato = false;

          this.$api.macchine.getForAgricoltore(this.form.id_agricoltore).then(response => {

            // Iterazione su tutte le macchine per verificare se esistono già
            response.data.forEach(element => {
              if (element.marca === dataMacchina.marca) {
                marcaTrovata = true;
                if (element.modello === dataMacchina.modello) {
                  modelloTrovato = true;
                  if (element.numero_serie === dataMacchina.numero_serie) {
                    numeroSerieTrovato = true;
                  }
                }
              }
            });

            if (!marcaTrovata || (marcaTrovata && !modelloTrovato) || (marcaTrovata && modelloTrovato && !numeroSerieTrovato)) {
              this.$api.macchine.createLocal(dataMacchina);
            }
          }).catch(error => {
            console.log("Nessuna macchina trovata");
            if (error.response.status == 404) this.$api.macchine.create(dataMacchina);
            console.log(error);
          })
        }
      }).catch(error => {
        console.log("Nessuna macchina trovata");
        if (error.response.status == 404) this.$api.macchine.create(dataMacchina);
        console.log(error);
      })
    },
    afterInitialize(prenotazione) {

      if (prenotazione && prenotazione.dettagli) {
        this.$set(this.form, 'dettagli', JSON.parse(prenotazione.dettagli))
        console.log(this.form)
      } else {
        this.$set(this.form, 'dettagli', { tipo: 1 })
      }
      //  Imposto l'ultimo indirizzo inserito se c'è
      if (!this.edit && this.$store.state.global.lastIndirizzo) {
        this.indirizzo = this.$store.state.global.lastIndirizzo
      }
    },
    formattaData(data) {
      if (!data) return ''
      const d = new Date(data)
      // Converte nel formato GG/MM/AAAA (es. 01/09/2026)
      return d.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.btn--indirizzo {
  button:nth-child(1) {
    border-bottom-right-radius: 0 !important;
    border-top-right-radius: 0 !important;
  }

  button:nth-child(2) {
    border-radius: 0 !important;
  }

  button:nth-child(3) {
    border-bottom-left-radius: 0 !important;
    border-top-left-radius: 0 !important;
  }

  .v-btn {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

}

.input-label {
  line-height: 64px;
  color: rgba(0, 0, 0, 0.54);
}

/* Stili specifici per il layout del PDF generato */
.pdf-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-bottom: 2px solid #2c3e50;
  padding-bottom: 10px;
  margin-bottom: 40px;

  .logo-left img, .logo-right img {
    height: 38px;
    width: auto;
  }
}

.font-bold {
  font-weight: 700;
  color: #1a1a1a;
}

.pdf-document {
  width: 210mm;
  padding: 18mm 22mm;
  font-family: 'Helvetica Neue', Arial, Helvetica, sans-serif;
  color: #1a1a1a;
  background-color: #fff;
  line-height: 1.45; // leggero aumento, aiuta la leggibilità con le righe DE sotto
}

.doc-title {
  font-size: 15pt;        // leggermente ridotto: ora il titolo è su due righe (IT+DE)
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.3px;
  color: #1a1a1a;
  margin-bottom: 30px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e0e0e0;
  line-height: 1.5;

  .lang-it {
    display: block;
    font-size: 0.7em;
    font-weight: 600;
    margin-top: 6px;
  }
}

.text-block {
  font-size: 11pt;
  color: #333;
  margin-bottom: 14px;   // era 10px — più spazio perché ora ogni blocco è due righe
}

.text-margin {
  margin-top: 26px;      // era 32px, ridotto leggermente per compensare l'altezza doppia dei blocchi
  margin-bottom: 14px;
}

.lang-it {
  display: block;
  font-style: italic;
  color: #555;
  font-size: 0.92em;
  margin-top: 3px;       // stacca visivamente la riga DE da quella IT sopra
}

.data-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  td {
    font-size: 11pt;
    padding: 4px 0;       // era 5px — le label ora sono due righe (IT+DE), servono per non far toccare le righe tra loro
    vertical-align: top;  // era 'bottom': con due righe di label, l'allineamento in alto sta meglio col valore accanto
  }

  .label {
    width: 230px;         // leggero aumento per via del tedesco più lungo (es. "des landwirtschaftlichen Betriebs:")
    color: #555;
    font-weight: 500;
    line-height: 1.3;

    .lang-it {
      font-weight: 400;
      margin-top: 1px;
    }
  }

  .value {
    padding-left: 40px;
    color: #1a1a1a;
  }
}

.indented-block {
  margin-left: 100px;
  margin-top: 8px;
  padding: 14px 16px;     // era 10px 16px — più aria interna, ora ci sono più righe (data+ora IT e DE)
  background-color: #f7f8fa;
  border-left: 3px solid #2c3e50;
  font-size: 11pt;
  line-height: 1.6;       // era 1.5

  p {
    margin: 5px 0;        // era 3px — separa meglio riga IT da riga DE sottostante
  }
}

.footer-signature {
  display: flex;
  justify-content: space-between;
  margin-top: 35px;       // era 65px — compensiamo perché date-side ora ha 2 righe invece di 1, riequilibrando l'altezza totale
  font-size: 11pt;
  color: #333;

  .date-side {
    width: 40%;
    line-height: 1.6;
  }

  .signature-side {
    width: 50%;

    .font-bold {
      line-height: 1.4;

      .lang-it.font-normal {
        display: block;
        font-weight: 400;
        font-style: italic;
        margin-top: 2px;
      }
    }

    .firma-img {
      max-height: 50px;   // leggermente ridotto (era 70px) per lasciare più margine di sicurezza sopra il nome tecnico
      max-width: 100%;
      width: auto;
      height: auto;
      object-fit: contain;
      display: block;
      margin: 4px 0;       // era 4px — evita che la firma tocchi "Il tecnico / Der technische Prüfer" sopra o il nome sotto
    }
  }
}

.pdf-offscreen-wrapper {
  position: absolute !important;
  left: -9999px !important;
  top: -9999px !important;
  width: 210mm;
  overflow: hidden;
  height: 0;
}

.pdf-hidden-container {
  position: absolute;
  left: -9999px;
  top: -9999px;
  width: 210mm; /* Forza la larghezza A4 */
  visibility: visible;
}
</style>


